import { render, staticRenderFns } from "./v-select.vue?vue&type=template&id=af882228&"
import script from "./v-select.vue?vue&type=script&lang=ts&"
export * from "./v-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports